import { Button, Dropdown } from '@appd/uik';
import { first, get, noop } from 'lodash';
import { getGlobals } from './DashboardViewer/globals';
import { getActionsRegistry } from '../actions';
import { useRouter } from 'next/router';

interface Props {
  children: any;
  editMode: boolean;
  className: string;
  filterList: any[];
}

export const EditorFilterBar = ({ children, filterList, editMode, className }: Props) => {
  const router = useRouter();
  const actionsRegistry = getActionsRegistry(router);
  const globals = getGlobals();

  const edit = (i: number[]) => {
    const id = get(children, `[${i}].props.name`);
    actionsRegistry.edit.onClick(id);
  };

  const addFilter = () => {
    actionsRegistry.addFilter.onClick();
  };

  const deleteFilter = (i: number[]) => {
    const id = get(children, `[${i}].props.name`);
    actionsRegistry.delete.onClick(id);
  };

  return (
    <div className={`flex gap-2 px-4 sticky top-0 z-10 bg-default-bg ${className}`}>
      <div className="flex flex-row gap-2 overflow-x-auto">
        {children.map((c: any, i: number) => (
          <div className="flex-none" key={i}>
            {c}
          </div>
        ))}
      </div>
      {editMode && (
        <div className="flex flex-col justify-center">
          {filterList && (
            <div className="flex">
              <Dropdown icon="Action.Edit" kind="TERTIARY" onSelect={edit}>
                {filterList.map((f, i) => (
                  <Dropdown.Option key={i}>{f.label}</Dropdown.Option>
                ))}
              </Dropdown>
              <Dropdown icon="Action.Delete" kind="TERTIARY" onSelect={deleteFilter}>
                {filterList.map((f, i) => (
                  <Dropdown.Option key={i}>{f.label}</Dropdown.Option>
                ))}
              </Dropdown>
            </div>
          )}
          <Button type="TERTIARY" icon="Action.Add" onClick={addFilter}>
            Add Filter
          </Button>
        </div>
      )}
    </div>
  );
};
